// extracted by mini-css-extract-plugin
module.exports = {"checkInput":"radio-button_checkInput__2EXzD"};